<template src="../../public/theme/base/languages.html"></template>

<script>
var Flags = require('emoji-flags')
export default {
  name: 'languagesComponent',
  computed: {
    languages() {
      return this.$store.getters.getSection('languages')
    },
  },
  methods: {
    getFlag(icon) {
      return Flags.countryCode(icon).emoji
    },
  },
}
</script>
